import { endOfDay, startOfDay } from 'date-fns';
import { UserPreferenceConstants } from './../../../../core/constants/user-preference-constants.constant';
import { DataTablePreference } from '../../../../core/models/user-preference';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Injector, Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { DeliveryOrderService } from '../../services/delivery-order.service';
import { BookingService } from './../../services/booking.service';
import {
  deepCopy,
  getDataScopeByPermission,
  isNullOrEmpty,
  onDropdownKeydown
} from 'src/app/core/utils/common-functions';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { Table } from 'primeng/table';
import { OptionsMappingPipe } from 'src/app/shared/pipes/options-mapping.pipe';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CodeConverterOptions } from 'src/app/core/models/options/code-converter-options';
import { DomSanitizer } from '@angular/platform-browser';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { SearchFormParameterGroupComponent } from 'src/app/shared/components/search-form-parameter-group/search-form-parameter-group.component';


@Component({
  selector: 'laas-do-search-for-shipping',
  templateUrl: './do-search-for-shipping.component.html',
  styleUrls: ['./do-search-for-shipping.component.scss']
})
export class DoSearchForShippingComponent extends SessionBaseComponent implements OnInit, AfterViewInit {

  @ViewChild('DODataTable') dataTable!: Table;
  @ViewChild(DataTableComponent) table!: DataTableComponent;
  readonly preferenceKey: string;
  readonly permissionCode = PermissionConstants.ViewQueryDo;
  readonly defaultSearchParams: any;
  readonly dayRange: number = 31;
  @ViewChild('etd') etd!: CalendarComponent;
  @ViewChild('invoiceDt') invoiceDt!: CalendarComponent;
  @ViewChild('createDtMO') createDtMO!: CalendarComponent;
  @ViewChild('parameterGroup') parameterGroupComp!: SearchFormParameterGroupComponent;

  currentLang: string = this.laasSetting.language;
  isSearchFormOpen: boolean;
  isShowEditDOModal: boolean;
  isShowReasonModal: boolean;
  isLoading: boolean;
  isSameCurrencyCode: boolean;
  columns: any[];
  // selectedCols: any[];
  DORows: any[];
  selectedDORows: any[];
  searchParams: any;
  DOStatusOptions: any[];
  DOBookingStatusOptions: any[];
  searchForm: FormGroup;
  letterHeadOptions: any[];
  orgIdsOptions: any[];
  shipCorpsOptions: any[];
  incotermOptions: any[];
  noShippingReasonOptions: any[];
  deliveryTypeOptions: any[];
  commonOptions: any[];
  facilityOptions: any[];
  orgIdList: any[];
  bookingForwarderOptions: any[];
  showDoFile: boolean;
  doNoFile: string;
  selectedDO: any;
  pageInfo: PageInfo;
  sortInfo: { property: string, direction: number } | null;
  waitingReasonOptions: any[];
  isShowControlledItemModal: boolean;
  isControlledItemList: any;
  extraWorkStatusOptions: any[];
  selectedCartonsInfo: {
    cartonCnt: string,
    totalNetWeight: string,
    totalGrossWeight: string,
    volumeWeight: string,
    cbm:string,
    pieces:string,
    price:string,
    currencyCode:string
  };
  // DO Address Confirm
  showAddressConfirm: boolean;
  confirmDos: any[];
  priorityOptions: any[];
  confirmStatusOptions: LaasOption[] = [];
  consigneeKeyOptions: any[];

  createrOptions: LaasOption[] = [];
  salesOptions: LaasOption[] = [];
  taskCodeOptions: LaasOption[] = [];
  frontLineDocStatusOptions: LaasOption[] = [];
  defaultCreateDtMO: Date[];

  excelDownloadSubmit: boolean;
  showShippingNotes: boolean;
  browserLanguage: string;
  shippingNotesDoNo: string;

  protected readonly onDropdownKeydown = onDropdownKeydown;

  constructor(
    injector: Injector,
    private DOService: DeliveryOrderService,
    private dropdownOptionsService: DropdownOptionsService,
    private commonDataService: CommonDataService,
    private bookingService: BookingService,
    private datePipe: DatePipe,
    private optionsMappingPipe: OptionsMappingPipe,
    private fb: FormBuilder,
    private translate: TranslateService,
    private addressMaintainanceService: AddressMaintainanceService,
    private sanitizer: DomSanitizer) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.DOSearchForShipping;
    this.defaultSearchParams = {
      doNos: [],
      tenants: [],
      letterHeadOrgIds: [],
      orgIds: [],
      shipCorps: [],
      consigneeKey: null,
      consigneeCompany: null,
      incoTerm: null,
      etdStart: null,
      etdEnd: null,
      deliveryType: null,
      dischargeType: null,
      invoiceDateStart: null,
      invoiceDateEnd: null,
      bookingCount: null,
      salesCode: [],
      status: [],
      doBookingStatus: null,
      isBookingNoExist: null,
      selectedFacility: [],
      isNoShippingReasonExist: null,
      isNormalizationAddressMaintained: null,
      bookingForwarder: [],
      dropType: null,
      invoiceNos : [],
      extraWorkStatus: null,
      mergeKeys: [],
      priority: null,
      taskCode:[],
      creater:[],
      consolidationIds: [],
      frontLineDocStatus: [],
      createDtMOStart: startOfDay(new Date().addDays(this.dayRange * -1)),
      createDtMOEnd: endOfDay(new Date())
    };
    this.isSearchFormOpen = true;
    this.isLoading = false;
    this.isShowEditDOModal = false;
    this.isShowReasonModal = false;
    this.waitingReasonOptions = [];
    this.priorityOptions = [
      { label: '5 - 一般單', value: '5' },
      { label: '1 - 急單', value: '1' }
    ];

    this.columns = [
      { field: '__function', header: 'DOQuery.Form.Column.Features', sort: false },
      { field: '__download', header: 'DOQuery.Form.Column.File', sort: false },
      { field: 'doNo', header: 'DOQuery.Form.Column.DONum', sort: true },
      { field: 'mergeKey', header: 'DOQuery.Form.Column.MergeKey', sort: true },
      { field: 'letterHeadOrgId', header: 'DOQuery.Form.Column.LetterHeadComp', sort: true },
      { field: 'shipCorp', header: 'DOQuery.Form.Column.ShipOutComp', sort: true },
      { field: 'orgId', header: 'DOQuery.Form.Column.LoadOrderComp', sort: true },
      { field: 'consigneeKey', header: 'DOQuery.Form.Column.CustomerCode', sort: true },
      { field: 'consigneeCompany', header: 'DOQuery.Form.Column.CustomerName', sort: true },
      { field: 'priority', header: 'DOQuery.Form.Column.Priority', sort: true},
      { field: 'incoTerm', header: 'DOQuery.Form.Column.TradeTerm', sort: true },
      { field: 'etd', header: 'DOQuery.Form.Column.ETD', sort: true },
      { field: 'eta', header: 'DOQuery.Form.Column.ETA', sort: true },
      { field: 'deliveryType', header: 'DOQuery.Form.Column.DeliveryLocate', sort: true },
      { field: 'dischargeType', header: 'DOQuery.Form.Column.DeliveryMode', sort: true },
      { field: 'shipToAddress', header: 'DOQuery.Form.Column.ShipAddr', sort: true },
      { field: 'deliveryToAddress', header: 'DOQuery.Form.Column.DeliverAddr', sort: true },
      { field: 'normalizationGroupId', header: 'DOQuery.Form.Column.GroupId', sort: true },
      { field: 'shipNotes', header: 'DOQuery.Form.Column.ShippingInstruct', sort: false },
      { field: 'cartonCnt', header: 'DOQuery.Form.Column.TotalCartonCnt', sort: true },
      { field: 'totalNetWeight', header: 'DOQuery.Form.Column.NetWeight', sort: true },
      { field: 'totalGrossWeight', header: 'DOQuery.Form.Column.GrossWeight', sort: true },
      { field: 'volumeWeight', header: 'DOQuery.Form.Column.VolumeWeight', sort: true },
      { field: 'cbm', header: 'DOQuery.Form.Column.Cbm', sort: false },
      { field: 'pieces', header: 'DOQuery.Form.Column.Pieces', sort: false },
      { field: 'price', header: 'DOQuery.Form.Column.Price', sort: false },
      { field: 'paymentTerm', header: 'DOQuery.Form.Column.PaymentTerm', sort: true },
      { field: 'storer', header: 'DOQuery.Form.Column.Storer', sort: true },
      { field: 'tenant', header: 'DOQuery.Form.Column.Group', sort: true },
      { field: 'invoiceNo', header: 'DOQuery.Form.Column.InvoiceNo', sort: true},
      { field: 'invoiceDate', header: 'DOQuery.Form.Column.InvoiceDT', sort: true },
      { field: 'waitingReference', header: 'DOQuery.Form.Column.WaitingReference', sort: true },
      { field: 'noShippingReasonLabel', header: 'DOQuery.Form.Column.OnHoldReason', sort: false },
      { field: 'csr', header: 'DOQuery.Form.Column.CSR', sort: true },
      { field: 'salesCode', header: 'DOQuery.Form.Column.Sales', sort: true },
      { field: 'dept', header: 'DOQuery.Form.Column.Department', sort: true },
      { field: 'doStatus', header: 'DOQuery.Form.Column.DOStatus', sort: true,  transform: (value: any) => this.optionsMappingPipe.transform(value, this.DOStatusOptions) },
      { field: 'outercaseArrivalDate', header: 'DOQuery.Form.Column.OutercaseArrivalDate', dataType: 'date', sort: true },
      { field: 'loadingDate', header: 'DOQuery.Form.Column.LoadingDate', sort: false },
      { field: 'leaveDate', header: 'DOQuery.Form.Column.LeaveDate', sort: false },
      { field: 'doBookingStatus', header: 'DOQuery.Form.Column.DOBookStatus', sort: true,  transform: (value: any) => this.optionsMappingPipe.transform(value, this.DOBookingStatusOptions) },
      { field: 'isDropRemark', header: 'DOQuery.Form.Column.DropShipFlag', sort: true },
      { field: 'bookingNo', header: 'DOQuery.Form.Column.BookingNum', sort: false },
      { field: 'bookingForwarder', header: 'DOQuery.Form.Column.BookingForwarder', sort: false },
      { field: 'assignForwarder', header: 'DOQuery.Form.Column.AssignForwarder', sort: false },
      { field: 'assignDate', header: 'DOQuery.Form.Column.AssignDate', sort: false },
      { field: 'facility', header: 'DOQuery.Form.Column.Facility', sort: true },
      { field: 'bookingCount', header: 'DOQuery.Form.Column.BOLCnt', sort: true },
      { field: 'license', header: 'DOQuery.Form.Column.License', sort: false },
      { field: 'sku', header: 'DOQuery.Form.Column.SKU', sort: false },
      { field: 'brand', header: 'DOQuery.Form.Column.Brand', sort: false },
      // { field: 'createDt', header: 'DOQuery.Form.Column.CreateDt', dataType: 'date', sort: true },
      { field: 'isConfirm', header: 'DOQuery.Form.Column.IsConfirm', sort: true },
      { field: 'extraWorkStatus', header: 'DOQuery.Form.Column.ExtraWorkStatus', sort: true},
      { field: 'frontLineDocStatus', header: 'DOQuery.Form.Column.FrontLineDocStatus', sort: true},
      { field: 'invoiceRemark', header: 'DOQuery.Form.Column.InvoiceRemark', sort: true },
      { field: 'assignmentInvoiceDt', header: 'DOQuery.Form.Column.AssignmentInvoiceDt', dataType: 'date', sort: true },
      { field: 'consolidationId', header: 'DOQuery.Form.Column.ConsolidationId', sort: true },
      { field: 'createDtMO', header: 'DOQuery.Form.Column.CreateDtMO', dataType: 'date', sort: true }
    ];


    const dataTablePreference = this.getDataTablePreference(this.preferenceKey);
    // this.selectedCols = this.mapToPreferenceColulmns(this.columns, dataTablePreference);
    this.sortInfo = isNullOrEmpty(dataTablePreference?.state?.sortField) || isNullOrEmpty(dataTablePreference?.state?.sortOrder) ? null :
      { property: dataTablePreference?.state?.sortField, direction: dataTablePreference?.state?.sortOrder };
    this.DORows = [];
    this.selectedDORows = [];
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.DOStatusOptions = [];
    this.DOBookingStatusOptions = [];
    this.searchForm = this.fb.group({
      doNos: [],
      tenants: [],
      letterHeadOrgId: [],
      orgIds: [],
      shipCorps: [],
      consigneeKey: null,
      consigneeCompany: null,
      incoTerm: null,
      etdStart: null,
      etdEnd: null,
      deliveryType: null,
      dischargeType: null,
      invoiceDateStart: null,
      invoiceDateEnd: null,
      bookingCount: null,
      salesCode: [],
      status: null,
      doBookingStatus: null,
      isBookingNoExist: null,
      selectedFacility: [],
      isNoShippingReasonExist: null,
      isNormalizationAddressMaintained: null,
      bookingForwarder: [],
      dropType: null,
      isConfirm: null,
      invoiceNos : [],
      extraWorkStatus: null,
      mergeKeys: [],
      priority: null,
      taskCode:[],
      creater:[],
      consolidationIds: [],
      frontLineDocStatus: [],
      createDtMOStart: startOfDay(new Date().addDays(this.dayRange * -1)),
      createDtMOEnd: endOfDay(new Date())
    });

    this.letterHeadOptions = [];
    this.orgIdsOptions = [];
    this.shipCorpsOptions = [];
    this.incotermOptions = [];
    this.noShippingReasonOptions = [];
    this.deliveryTypeOptions = [];
    this.orgIdList = [];
    this.commonOptions = [];
    this.bookingForwarderOptions = [];
    this.showDoFile = false;
    this.doNoFile = '';
    this.pageInfo = { pageSize: 5, pageIndex: 0, totalRecords: 0, totalPages: 0 };
    this.showAddressConfirm = false;
    this.confirmDos = [];
    this.facilityOptions = [];
    this.isShowControlledItemModal = false;
    this.isControlledItemList = [];
    this.selectedCartonsInfo = {
      cartonCnt: "",
      totalNetWeight: "",
      totalGrossWeight: "",
      volumeWeight: "",
      cbm: "",
      pieces: "",
      price: "",
      currencyCode: ""
    };
    this.extraWorkStatusOptions = [];
    this.consigneeKeyOptions = [];
    this.frontLineDocStatusOptions = [];
    this.isSameCurrencyCode = true;
    this.defaultCreateDtMO = [startOfDay(new Date().addDays(this.dayRange * -1)), endOfDay(new Date())];

    this.excelDownloadSubmit = false;
    this.showShippingNotes = false;
    this.browserLanguage = '';
    this.shippingNotesDoNo = '';
  }

  // @Input() get selectedColumns(): any[] {
  //   return this.selectedCols;
  // }

  // set selectedColumns(cols: any[]) {
  //   this.selectedCols = this.columns.filter(col => cols.includes(col));
  // }

  get dataTablePreference(): DataTablePreference | null {
    return this.userService.preference.dataTablePreferences.find(x => x.tableName === this.preferenceKey) ?? null;
  }

  async ngOnInit(): Promise<void> {
    this.logger.info('DOSearchForShippingComponent onInit.');
    await super.ngOnInit();

    this.commonOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    this.dropdownOptionsService.getDOStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getDOBookingStatusOptions()
      .subscribe({
        next: (options: any[]) => {
          this.DOBookingStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getLetterOrgOptions()
      .subscribe({
        next: (options: any[]) => {
          this.letterHeadOptions = this.orgIdsOptions = this.shipCorpsOptions = options;
          this.orgIdList = options.map(x => ({ label: `${x.legalEntityOUName}`, value: x.legalEntityOUCode }));
        }
      });
    this.dropdownOptionsService.getIncoTermOptions()
      .subscribe({
        next: (options: any[]) => {
          this.incotermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.dropdownOptionsService.getDeliveryTypeOptions(false)
      .subscribe({
        next: (options: any[]) => {
          this.deliveryTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'NoShippingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.noShippingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'WaitingReason', this.laasSetting.facility)
      .subscribe({
        next: (models: any[]) => {
          this.waitingReasonOptions = models.map(x => ({ label: x.codeDesc, value: x.codeKey }));
        }
      });

      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "ExtraWorkStatus").subscribe({
        next: (options: CodeConverterOptions[]) => {
          this.extraWorkStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        }
      });

    this.dropdownOptionsService.getFacilityOptions()
      .subscribe({
        next: (options: any[]) => {
          this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.bookingForwarderOptions = result;
        }
      });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "MergeKeyConfirmStatus").subscribe({
        next: (options: CodeConverterOptions[]) => {
          this.confirmStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        }
      });

      this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "FrontLineDocStatus").subscribe({
        next: (options: CodeConverterOptions[]) => {
          this.frontLineDocStatusOptions = options.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
        }
      });

      this.addressMaintainanceService.getCustomerOptions().subscribe({
        next: (result) => {
          this.consigneeKeyOptions = [...result].map((x: any) => {
            return {
              label: `${x.customerCode} - ${x.customerName}`,
              value: x.customerCode,
            };
          });
        },
      });

    // rbac to maintain this page
    const canInPage = this.permissionCodes.includes(this.permissionCode);
    if (!canInPage) {
      // go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    if (this.laasSetting.language == 'en-us') {
      this.priorityOptions = [
        { label: '5 - Normal', value: '5' },
        { label: '1 - Urgent', value: '1' }
      ];
    } else if (this.laasSetting.language == 'zh-tw') {
      this.priorityOptions = [
        { label: '5 - 一般單', value: '5' },
        { label: '1 - 急單', value: '1' }
      ];
    }

    this.dropdownOptionsService.getCsrOptionsIsEmployeeCode().subscribe({
      next: (options: any[]) => {
        this.createrOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getSalesOptions().subscribe({
      next: (options: any[]) => {
        this.salesOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    //TODO 後端下拉選單 Logistics.Task
    this.dropdownOptionsService.getTaskCodeOptions(true,'DeliveryOrder').subscribe({
      next: (options: any[]) => {
        this.taskCodeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        this.taskCodeOptions = this.taskCodeOptions.sort((a, b) =>
          a.value > b.value ? 1 : -1
        );
      }
    });
  this.searchForm.patchValue(this.defaultSearchParams);
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');
    console.log(this.pageInfo);
  }

  // ngOnDestroy(): void {
  //   this.logger.info('DOSearchForShippingComponent onDestroy.');
  //   super.ngOnDestroy();
  //   if (this.authenticationService.isAuthenticated) {
  //     this.savePagePreference();
  //   }
  // }

  // /**
  //  * Logout event callback.
  //  */
  // onLogout(): void {
  //   this.logger.info('DOSearchForShippingComponent onLogout.');
  //   super.onLogout();
  //   this.savePagePreference();
  // }

  /**
   * Search form search button click event.
   * @param event Button click event.
   */
  searchBtnClick(event?: any): void {
    this.excelDownloadSubmit = false;
    this.selectedDORows.length = 0;
    this.pageInfo.pageIndex = 0;
    this.resetCartonsInfo();
    this.table.setCurrentPage(0);
    const formValues = this.searchForm.getRawValue();
    Object.assign(this.searchParams, formValues);
    this.loadDOsForDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  /**
   * File upload button click event.
   * @param event Button click event.
   * @param rowData DO detail.
   */
  fileBtnClick(event: any, rowData: any): void {
    this.doNoFile = rowData.doNo;
    this.showDoFile = true;
  }

  closeFile(display: boolean): void {
    this.showDoFile = display;
  }

  closeAddressConfirm(display: boolean): void {
    this.showAddressConfirm = display;
  }

  /**
   * Search form reset button click event.
   * @param event Button click event.
   */
  resetBtnClick(event: any): void {

    this.etd.ngOnInit();
    this.invoiceDt.ngOnInit();
    this.createDtMO.ngOnInit();
    this.searchForm.reset();
    this.parameterGroupComp.clearSelection();
    this.searchParams.invoiceDateStart = null;
    this.searchParams.invoiceDateEnd = null;
    this.searchParams.etdStart = null;
    this.searchParams.etdEnd = null;
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.searchForm.patchValue(this.searchParams);
  }

  addressBtnClick(event: any, rowData: any): void {
    this.confirmDos = [];
    this.confirmDos.push(rowData);
    this.showAddressConfirm = true;
  }

  editBtnClick(event: any, DO: any): void {
    this.isShowEditDOModal = true;
    this.selectedDO = DO;
    this.selectedDO.dropType = this.selectedDO.dropType ?? 'I';
  }

  /**
   * No shipping reason edit button click event.
   * @param event Button click event.
   * @param DO DO detail.
   */
  reasonBtnClick(event: any, DO: any): void {
    this.isShowReasonModal = true;
    this.selectedDO = DO;
  }

  /**
   * Preview booking button click event.
   * @param event Button click event.
   */
  createBookingBtnClick(event: any): void {
    this.routeStateService.navigateTo('/TransportOperation/BookingCreation', this.selectedDORows);
  }

  /**
   * Auto booking button click event.
   * @param event Button click event.
   */
  autoBookingBtnClick(event: any): void {
    // if (!this.checkDOListStatus(this.selectedDORows)) {
    //   return;
    // }
    //是否確定執行自動派車
    this.translateService.get('DOSearchForShip.Confirm.ConfirmAutoBooking')
    .subscribe({
      next: confirmAutoBooking => {
        this.confirmationService.confirm({
          message: confirmAutoBooking,
          acceptLabel: '是',
          rejectLabel: '否',
          accept: () => {
            const doNos = this.selectedDORows.map(x => x.doNo);
            this.batchUpdateDOStatus(doNos);
          }
        });
      }
    });

  }

  /**
   * No shipping reason modal hide event.
   * @param event p-dialog onHide event.
   */
  editModalHide(event: any): void {
    this.selectedDO = null;
  }

  /**
   * No shipping reason modal confirm button click event.
   * @param event Button click event.
   */
  reasonModalConfirmBtnClick(event: any): void {
    this.DOService.updateNoShippingReasonByDoNo(
      this.selectedDO.doNo,
      this.selectedDO.noShippingReason,
      this.userProfile.userName)
      .subscribe({
        next: () => {
          this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.searchBtnClick(null);
                this.toastService.success(msg);
                this.isShowReasonModal = false;
              },
              error: (err: HttpErrorResponse) => {
                this.toastErrorMessage(err.error);
              }
            });
        }
      });
  }

  /**
   * Carton count edit modal hide event.
   * @param event laas-drop-ctn-modiy modalClosed event.
   */
  modalCancelBtnClick(event: any): void {
    this.isShowEditDOModal = false;
    this.selectedDO = null;
  }

  /**
   * No shipping reason modal cancel button click event.
   * @param event Button click event.
   */
  reasonModalCancelBtnClick(event: any): void {
    this.isShowReasonModal = false;
  }

  setPageSize(event: any): void{
    this.pageInfo.pageSize = event.rows;
  }

  /**
   * Datatable paging event.
   * @param event p-table onPage event.
   */
  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.loadDOsForDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  tableSort(event: any): void {
    this.sortInfo = { property: event.field, direction: event.order };
    this.loadDOsForDataTable(this.pageInfo.pageIndex, this.pageInfo.pageSize, this.sortInfo);
  }

  /**
   * DO number field add event.
   * @param event p-chips onAdd event.
   */
  doNoChipsAdd(event: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    this.searchParams.doNos.splice(this.searchParams.doNos.indexOf(value));
    this.searchParams.doNos = this.searchParams.doNos.concat(parsedValues);
  }

  reWriteDo(event: any): void{

    var thisDo = this.DORows.filter((x: any) => {
      return x.doNo === event.doNo;
    });

    if(thisDo.length > 0){
      thisDo[0].normalizationAddress = event.normalizationAddress;
      thisDo[0].assignmentDistrictId = event.assignmentDistrictId;
      thisDo[0].normalizationCity = event.normalizationCity;
      thisDo[0].normalizationCountry = event.normalizationCountry;
    }


    console.log(event);
  }

  /**
   * Export to excel.
   * @param event p-button click event
   */
  async exportExcel(event: any): Promise<void> {
    this.excelDownloadSubmit = true;
    this.downloadExcelFile(null, null, this.sortInfo);
  }

  parameterGroupChange(event: any): void {
    if (isNullOrEmpty(event)) {
      this.searchParams = deepCopy(this.defaultSearchParams);
      this.searchForm.patchValue(this.searchParams);
      this.etd.ngOnInit();
      this.invoiceDt.ngOnInit();
      this.createDtMO.ngOnInit();
    } else {
      this.searchParams = { ...event.data };
      this.searchForm.patchValue(this.searchParams, { emitEvent: false });
      this.createDtMO.syncUIFromOutside([this.searchParams.createDtMOStart, this.searchParams.createDtMOEnd]);
      this.etd.syncUIFromOutside([this.searchParams.etdStart, this.searchParams.etdEnd]);
      this.invoiceDt.syncUIFromOutside([this.searchParams.invoiceDateStart, this.searchParams.invoiceDateEnd]);
    }
    this.searchForm.patchValue({ selectedFacility: this.searchParams.selectedFacility });
  }

  unBookmarked(event: any): void {
    this.searchParams = deepCopy(this.defaultSearchParams);
    this.etd.ngOnInit();
    this.invoiceDt.ngOnInit();
    this.createDtMO.ngOnInit();
    this.searchForm.patchValue({ selectedFacility: this.searchParams.selectedFacility });
  }

  displayMessageArray(msgStr: string): string {
    if (isNullOrEmpty(msgStr)) {
      return '';
    }
    const array = msgStr.split('｜').filter(x => isNullOrEmpty(x) === false);
    if (array.length === 0) {
      return '';
    }
    const context = array.map((x, idx) => `${idx + 1}. ${x}`).join('\n');
    return context;
  }

  private loadDOsForDataTable(pageIndex: number | null, pageSize: number | null, sort?: any): void {
    this.isLoading = true;
    if (this.customValidator(this.searchForm) != null) {
      this.toastService.error(
        this.translateService.instant('DOQuery.Button.Error.DownloadExcelRequiredValue')
      );
      this.isLoading = false;
      return;
    }
    this.loadDeliveryOrdersForShipping(pageIndex, pageSize, sort)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: result => {
          this.isSearchFormOpen = false;
          this.DORows = result.content.map((x: any) => {
            x.reasons = this.getFormatedReasons(x);
            x.waitingReference = this.getFormatedFixedRemark(x);
            x.isConfirm = (isNullOrEmpty(x.isConfirm) ? "" : x.isConfirm.toString());
            return x;
          });
          this.pageInfo.totalRecords = result.totalElements;
          this.pageInfo.totalPages = result.totalPages;
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err);
        }
      });
  }

  private loadDeliveryOrdersForShipping(pageIndex: number | null, pageSize: number | null, sort?: any): Observable<any> {
    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.userLanguage = this.laasSetting.language;
    params.pageIndex = pageIndex;
    params.pageSize = pageSize;
    params.sortOrders = isNullOrEmpty(sort) ? null : [sort];
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.statuses = isNullOrEmpty(params.status) ? [] : params.status;
    params.etdStart = isNullOrEmpty(params.etdStart) ? null : new Date(params.etdStart).toISOString();
    params.etdEnd = isNullOrEmpty(params.etdEnd) ? null : new Date(params.etdEnd).toISOString();
    params.invoiceDateStart = isNullOrEmpty(params.invoiceDateStart) ? null : new Date(params.invoiceDateStart).toISOString();
    params.invoiceDateEnd = isNullOrEmpty(params.invoiceDateEnd) ? null : new Date(params.invoiceDateEnd).toISOString();
    params.createDtMOStart = isNullOrEmpty(params.createDtMOStart) ? null : new Date(params.createDtMOStart).toISOString();
    params.createDtMOEnd = isNullOrEmpty(params.createDtMOEnd) ? null : new Date(params.createDtMOEnd).toISOString();
    return this.DOService.getDeliveryOrdersForShipping(params);
  }

  private batchUpdateDOStatus(doNos: string[]): void {
    this.DOService.updateStatusByDONos(doNos, 'AT', this.userProfile.userName)
      .subscribe({
        next: () => {
          //已加入自動派車佇列，系統將在 15 分鐘內執行作業
          this.translateService.get('DOSearchForShip.Success')
            .subscribe({
              next: result => {
                this.toastService.success(result);
              }
            });

          this.searchBtnClick();
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  isNeedMaintainAddress(doObj: any): boolean {

    var isNeed = false;

    var address = `${this.handleAddress(doObj.deliveryToAddress2)} ${this.handleAddress(doObj.deliveryToAddress3)} ${this.handleAddress(doObj.deliveryToAddress4)} ${this.handleAddress(doObj.deliveryToAddress5)}`;

    if (address.trim() == "") {
      address = `${this.handleAddress(doObj.consigneeAddress2)} ${this.handleAddress(doObj.consigneeAddress3)} ${this.handleAddress(doObj.consigneeAddress4)} ${this.handleAddress(doObj.consigneeAddress5)}`;
    }

    if (doObj.deliveryType?.toUpperCase().startsWith('LOCAL')) {
      //local
      isNeed = isNullOrEmpty(doObj.normalizationAddress) || isNullOrEmpty(doObj.assignmentDistrictId);
    } else {
      //export
      isNeed = isNullOrEmpty(doObj.normalizationAddress) || isNullOrEmpty(doObj.normalizationCity) || isNullOrEmpty(doObj.normalizationCountry);
    }
    return isNeed && this.permissionCodes.includes(PermissionConstants.BtnAssignmentDistrictMaintain);
  }

  private handleAddress(address?: string): string {
    if (isNullOrEmpty(address)) {
      return "";
    }
    return address == null ? "" : address;
  }

  private getFormatedReasons(rowData: any): string[] {
    return this.optionsMappingPipe.transform(rowData.noShippingReason, this.noShippingReasonOptions);
  }

  private getFormatedFixedRemark(rowData: any): string[] {
    let waitingReasons = (isNullOrEmpty(rowData.waitingReason) ? [] : rowData.waitingReason.split(','))
      .map((x: string) => {
        return this.optionsMappingPipe.transform(x, this.waitingReasonOptions);
      });
    return rowData.waitingReason

  }

  selectedRowsChange(event: any): void {
    if (this.selectedDORows.length > 0) {
      const reducer = (accumulator: any, currentValue: any) => accumulator + currentValue;
      this.selectedCartonsInfo.cartonCnt = this.calculateTotalProperty(this.selectedDORows, 'cartonCnt',reducer,false);
      this.selectedCartonsInfo.totalGrossWeight = this.calculateTotalProperty(this.selectedDORows, 'totalGrossWeight',reducer,false);
      this.selectedCartonsInfo.totalNetWeight = this.calculateTotalProperty(this.selectedDORows, 'totalNetWeight',reducer,false);
      this.selectedCartonsInfo.volumeWeight = this.calculateTotalProperty(this.selectedDORows, 'volumeWeight',reducer,false);
      this.selectedCartonsInfo.cbm = this.calculateTotalProperty(this.selectedDORows, 'cbm',reducer,true);
      this.selectedCartonsInfo.pieces = this.calculateTotalProperty(this.selectedDORows, 'pieces',reducer,false);
      this.selectedCartonsInfo.price = this.calculateTotalProperty(this.selectedDORows, 'price',reducer,false);
      this.isCurrencyCode();
    }
    else{
      this.resetCartonsInfo();
    }
  }

  //因為下面使用string來進行千分位格式轉換  所以回傳也要是string否則會顯示NaN
  calculateTotalProperty(rows: any[], property: string, reducer: any,isCeil:boolean): string {
    const sum = rows
      .filter(x => x[property] != null)
      .map(x => x[property])
      .reduce(reducer, 0);
      var formattedSum;
      if(Number.isInteger(sum)){
        formattedSum = sum.toString();
      }else if(isCeil){
        formattedSum = this.roundUp(sum,2);
      }else {
        formattedSum = sum.toFixed(2);
      }
      return this.formatNumber(formattedSum);
  }

  formatNumber(num: string) {
    var parts = num.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  roundUp( num:number, decimal:number ) {
     return Math.ceil( ( num + Number.EPSILON ) * Math.pow( 10, decimal ) ) / Math.pow( 10, decimal ); }

  resetCartonsInfo():void{
    this.selectedCartonsInfo = {
      cartonCnt: "",
      totalNetWeight: "",
      totalGrossWeight: "",
      volumeWeight: "",
      cbm: "",
      pieces: "",
      price: "",
      currencyCode: ""
    };
  }

  downloadExcelFile(pageIndex: number | null, pageSize: number | null, sort?: any): void {
    this.isLoading = true;
    const params = deepCopy(this.searchParams);
    if (this.customValidator(this.searchForm) != null) {
      this.toastService.error(
        this.translateService.instant('DOQuery.Button.Error.DownloadExcelRequiredValue')
      );
      this.isLoading = false;
      return;
    }
    params.facility = this.laasSetting.facility;
    params.userLanguage = this.laasSetting.language;
    params.pageIndex = pageIndex;
    params.pageSize = pageSize;
    params.sortOrders = isNullOrEmpty(sort) ? null : [sort];
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    params.statuses = isNullOrEmpty(params.status) ? [] : params.status;
    params.etdStart = isNullOrEmpty(params.etdStart) ? null : new Date(params.etdStart).toISOString();
    params.etdEnd = isNullOrEmpty(params.etdEnd) ? null : new Date(params.etdEnd).toISOString();
    params.invoiceDateStart = isNullOrEmpty(params.invoiceDateStart) ? null : new Date(params.invoiceDateStart).toISOString();
    params.invoiceDateEnd = isNullOrEmpty(params.invoiceDateEnd) ? null : new Date(params.invoiceDateEnd).toISOString();
    params.createDtMOStart = isNullOrEmpty(params.createDtMOStart) ? null : new Date(params.createDtMOStart).toISOString();
    params.createDtMOEnd = isNullOrEmpty(params.createDtMOEnd) ? null : new Date(params.createDtMOEnd).toISOString();

    this.DOService.getDoQueryResultExcel(params).subscribe(result => {

      var blob = this.base64ToBlob(result.base64File);

      let downloadURL = window.URL.createObjectURL(blob);
      let link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'Do Search Result.xlsx'
      link.click();
      this.isLoading = false;
    });

  }
  base64ToBlob(b64Data: string, sliceSize=512) {
    let byteCharacters = atob(b64Data); //data.file there
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'});
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  doNoLinkClick(event: any, rowData: any): void {
    this.routeStateService.navigateTo(
      '/TransportOperation/DoDetailForShipping',
      rowData,
      true
    );
    }
  dateOnChange(date: any,type:string) {
    switch(type){
      case "etd" :
        this.searchParams.etdStart = date.startDate;
        this.searchParams.etdEnd = date.endDate;
        this.searchForm.patchValue({
          etdStart: date.startDate,
          etdEnd: date.endDate
          });
        break;
      case "invoiceDt":
        if (!isNullOrEmpty(date.startDate)) {
          this.searchParams.invoiceDateStart = date.startDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateStart = date.startDate;
        }

        if (!isNullOrEmpty(date.endDate)) {
          this.searchParams.invoiceDateEnd = date.endDate.setSeconds(0);
        } else {
          this.searchParams.invoiceDateEnd = date.endDate;
        }
        this.searchForm.patchValue({
          invoiceDateStart: this.searchParams.invoiceDateStart,
          invoiceDateEnd: this.searchParams.invoiceDateEnd
        });
        break;
      case 'createDtMO':
        //this.searchForm.controls.createDtMOStart.setValue(date.startDate);
        //this.searchForm.controls.createDtMOEnd.setValue(date.endDate);
        if (!isNullOrEmpty(date.startDate)) {
          this.searchParams.createDtMOStart = date.startDate.setSeconds(0);
        } else {
          this.searchParams.createDtMOStart = date.startDate;
        }

        if (!isNullOrEmpty(date.endDate)) {
          this.searchParams.createDtMOEnd = date.endDate.setSeconds(0);
        } else {
          this.searchParams.createDtMOEnd = date.endDate;
        }
        this.searchForm.patchValue({
          createDtMOStart: this.searchParams.createDtMOStart,
          createDtMOEnd: this.searchParams.createDtMOEnd
        });
        break;
    }
  }

  showDateOnChange(event: any) {
    console.log(event);
    if (!isNullOrEmpty(event.data.invoiceDateStart)) {
      const invoiceDateStart = new Date(event.data.invoiceDateStart);
      if (isNullOrEmpty(event.data.invoiceDateEnd)) {
        this.invoiceDt.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.invoiceDt.changeShowDate(invoiceDateStart);
        }, 400);
      } else {
        this.invoiceDt.changeSelectMode('Range');
        setTimeout(() => {
          this.invoiceDt.changeShowDate([invoiceDateStart, new Date(event.data.invoiceDateEnd)]);
        }, 400);
      }
    }

    if (!isNullOrEmpty(event.data.etdStart)) {
      const etdStart = new Date(event.data.etdStart);
      if (isNullOrEmpty(event.data.etdEnd)) {
        this.etd.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.etd.changeShowDate(etdStart);
        }, 400);
      } else {
        this.etd.changeSelectMode('Range');
        setTimeout(() => {
          this.etd.changeShowDate([etdStart, new Date(event.data.etdEnd)]);
        }, 400);
      }
    }

    if (!isNullOrEmpty(event.data.createDtMOStart)) {
      const createDtMOStart = new Date(event.data.createDtMOStart);
      if (isNullOrEmpty(event.data.createDtMOEnd)) {
        this.createDtMO.changeSelectMode('Start');
        //change mode 完會延遲200ms clear date
        setTimeout(() => {
          this.createDtMO.changeShowDate(createDtMOStart);
        }, 400);
      } else {
        this.createDtMO.changeSelectMode('Range');
        setTimeout(() => {
          this.createDtMO.changeShowDate([createDtMOStart, new Date(event.data.createDtMOEnd)]);
        }, 400);
      }
    }
  }

  isCurrencyCode() {
    let referenceCurrencyCode: string | null = null;
    //有些DO沒有發票 要找第一個不是Null的當參考值
    for (let i = 0; i < this.selectedDORows.length; i++) {
      if (this.selectedDORows[i].currencyCode !== null) {
        referenceCurrencyCode = this.selectedDORows[i].currencyCode;
        break;
      }
    }

    // 如果所有都是 null=>true
    if (referenceCurrencyCode === null) {
      this.isSameCurrencyCode = true;
      return;
    }

    const filteredRows = this.selectedDORows.filter(row => row.currencyCode !== null);

    if (filteredRows.every(row => row.currencyCode === referenceCurrencyCode)) {
      this.isSameCurrencyCode = true;
      this.selectedCartonsInfo.currencyCode = referenceCurrencyCode;
    } else {
      this.isSameCurrencyCode = false;
    }
  }

  customValidator(control: AbstractControl): ValidationErrors | null {
    console.log('doNos',this.searchParams.doNos, 'this.searchParams.createDtMOStart', this.searchParams.createDtMOStart);
    if ((this.searchParams.doNos == null || this.searchParams.doNos == undefined || this.searchParams.doNos.length == 0) && (this.searchParams.createDtMOStart == null || this.searchParams.createDtMOStart == undefined)) {
      return { requiredFields: true };
    }


    return null; // 验证通过
  }

  shippingNotesClick(event: any, rowData: any) {
    this.shippingNotesDoNo = rowData.doNo;
    this.showShippingNotes = true;
  }

  closeShipNotesDialog(event: any): void {
    this.showShippingNotes = false;
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'selectedFacility':
        this.searchParams.selectedFacility = data;
        break;
    }
  }
}
